import clipping from 'polygon-clipping';

/** Retry derived-surface booleans on a local integer grid when independently
 * projected edges differ only at floating-point precision and break ring
 * assembly. Every operand, including holes, participates in the same operation.
 * Editable source geometry is never changed, omitted or replaced by a hull. */
export function clipWithPrecisionRetry(operation, ...operands) {
  try { return clipping[operation](...operands); }
  catch (originalError) {
    let origin;
    const locate = values => {
      if (origin || !Array.isArray(values)) return;
      if (typeof values[0] === 'number') {
        if (values.length === 2 && values.every(Number.isFinite)) origin = values;
      } else values.forEach(locate);
    };
    operands.forEach(locate);
    if (!origin) throw originalError;
    // 10-nanometre rounding is restricted to the derived boolean operands.
    const scale = 1e8;
    const encode = values => typeof values[0] === 'number'
      ? values.map((n, axis) => Math.round((n - origin[axis]) * scale))
      : values.map(encode);
    const joined = clipping[operation](...operands.map(encode));
    return joined.map(rings => rings.map(boundary => boundary.map(p => p.map((n, axis) => n / scale + origin[axis]))));
  }
}
